import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "label", "filename", "fileList"]
  static values = {
    oneFileText: { type: String, default: "1 file selected" },
    filesSelectedTemplate: { type: String, default: "{count} files selected" }
  }

  click(event) {
    if (event.target !== this.inputTarget) {
      this.inputTarget.click()
    }
  }

  dragover(event) {
    event.preventDefault()
    event.currentTarget.classList.add("border-indigo-500", "bg-indigo-50")
  }

  dragleave(event) {
    event.preventDefault()
    event.currentTarget.classList.remove("border-indigo-500", "bg-indigo-50")
  }

  drop(event) {
    event.preventDefault()
    event.currentTarget.classList.remove("border-indigo-500", "bg-indigo-50")

    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.inputTarget.files = files
      this.updateUI(files)
    }
  }

  change(event) {
    const files = event.target.files
    if (files.length > 0) {
      this.updateUI(files)
    }
  }

  updateUI(files) {
    if (files.length === 1) {
      this.labelTarget.textContent = this.oneFileTextValue
      this.filenameTarget.textContent = files[0].name
      if (this.hasFileListTarget) {
        this.fileListTarget.innerHTML = ""
      }
    } else {
      this.labelTarget.textContent = this.filesSelectedTemplateValue
        .replace("{count}", files.length)
      this.filenameTarget.textContent = ""

      if (this.hasFileListTarget) {
        this.fileListTarget.innerHTML = Array.from(files).map(file =>
          `<li class="text-sm text-gray-600">${this.escapeHtml(file.name)}</li>`
        ).join("")
      }
    }

    // Notify sibling controllers (e.g. upload-mode) of the new file count.
    this.dispatch("filesChanged", { detail: { count: files.length } })
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
